import './modal-search-user.scss';
import Input from '../../components/input/input';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/free-solid-svg-icons'
import EmptyState from '../../assets/empty-state.png';
import { useState, useEffect } from 'react';
import LocalStorage from '../../services/local-storage';
import IndividualChallengeService from '../../services/individual-challenge-service';
import { TEAM, SESSION } from '../../constants';
import axios from "axios";
import { ASSETS } from '../../constants';
import ModalTemplate from '../modal-template/modal-template';
import TranslateService from '../../services/translate-service';
import Avatar from '../avatar/avatar';

export default function ModalSearchUser(props) {

    const [signal, setSignal] = useState(undefined);

    const [team] = useState(LocalStorage.get(TEAM));
    const [session] = useState(LocalStorage.get(SESSION));

    const [term, setTerm] = useState('');
    const [result, setResult] = useState([]);


    useEffect(() => {
        if(!props.isOpen) {
            setSignal(undefined);
            setTerm('');
            setResult([]);
        }
    }, [props.isOpen]);

    useEffect(() => {
        if (term) {
            if (typeof signal != typeof undefined) {
                signal.cancel("Operation canceled due to new request.")
            }

            setSignal(axios.CancelToken.source());
        } else {
            setResult([]);
        }
    }, [term]);

    useEffect(() => {
        async function fetchData() {
            if (signal) {
                const response = await IndividualChallengeService.searchPlayers(session._id, team.area._id, term, signal.token);
                if (Array.isArray(response)) {
                    setResult(response);
                } else {
                    setResult([]);
                }
            }
        }

        fetchData();
    }, [signal, session._id, team.area._id, term]);

    return (
        <ModalTemplate isOpen={props.isOpen} className="modal-search-user">
            <div className='flex items-center'>
                <div className='heading-h4 grow'>{TranslateService.get('modal.search.title')}</div>
                <div>
                    <button className='btn-close ' onClick={props.onClose}>
                        <FontAwesomeIcon icon={faClose} />
                    </button>
                </div>
            </div>

            <div className='my-[24px]'>
                <Input placeholder={TranslateService.get('modal.search.search')} label={TranslateService.get('modal.search.search')} onChange={(ev) => setTerm(ev.target.value)} value={term}  />
            </div>

            <div className='results'>
                {(!signal || !result.length) &&
                    <div className='text-center'>
                        <img src={EmptyState} alt='' className='w-[237px] m-auto' />
                        <p className='heading-h6 mt-5'>{term ? TranslateService.get('modal.search.notFound') : 'Escribe en la barra de busqueda para encontrar un compañero'}</p>
                    </div>
                }

                {
                    result.map(player => (
                        <div className='flex items-center separator-bottom p-[16px]' key={player._id}>
                            <div className='flex items-center grow'>
                                <Avatar className='mx-auto clean' image={ `${ASSETS.AVATAR_PLAYER}${player.avatar}` }/>
                                <div className='ml-3 grow'>
                                    <p className=''>{player.nombre} {player.apellidoPaterno}</p>
                                    {player.existeJuego && <p className='text-secundary'>{TranslateService.get('modal.search.challenge.active')}</p>}
                                </div>
                            </div>

                            {!player.existeJuego &&
                                <div>
                                    <p className='link font-family-montserrat uppercase !font-bold !text-[12px] cursor-pointer' onClick={() => props.onChallenge(player._id)}>{TranslateService.get('modal.search.challenge.link')}</p>
                                </div>
                            }

                        </div>
                    ))
                }


            </div>
        </ModalTemplate>
    )
}